import type { ArticlePreview } from "@brookbush/types";

import Image from "next/image";
import Link from "next/link";

const ArticlesCard = ({ slug, title, thumbnail }: ArticlePreview) => {
	return (
		<Link
			href={`/articles/${slug}`}
			className="article-card group relative mx-auto flex phablet:aspect-[5/3] phablet:max-w-full cursor-pointer phablet:flex-col overflow-hidden phablet:rounded-2xl rounded-xl border phablet:border bg-white transition-all phablet:duration-300 phablet:hover:scale-105 hover:bg-slate-50 phablet:hover:shadow-xl dark:bg-slate-800 dark:shadow-slate-900 dark:hover:bg-slate-700"
		>
			<div className="phablet:absolute relative aspect-square h-20 phablet:h-full phablet:w-full w-20 shrink-0 overflow-hidden border-r tablet:border-r-0 transition-all duration-700">
				<Image
					src={
						thumbnail?.url ||
						"/logos/brookbush-institute-logo-icon-primary-bg.png"
					}
					fill
					placeholder="empty"
					className="object-cover"
					alt={title}
				/>
			</div>
			<div className="absolute top-0 left-0 phablet:flex hidden h-full w-full flex-col items-start justify-end gap-2.5 bg-gradient-to-t from-black/90 to-transparent px-3.5 py-2.5">
				<h3 className={`line-clamp-2 font-semibold text-lg text-white`}>
					{title}
				</h3>
			</div>
			<h3 className="line-clamp-3 phablet:hidden p-1 pl-2 font-medium">
				{title}
			</h3>
		</Link>
	);
};

export default ArticlesCard;
